<template>
  <modal>
    <div slot="modal-content">
      <card class="confirmation">
        <div class="confirmation__wrapper">
          <p class="confirmation__question">Are you sure?</p>
          <div class="confirmation__choose">
            <p-button
              class="confirmation__btn"
              size="md"
              type="default"
              outline
              @click.native="itemInterection"
              >Yes</p-button
            >
            <p-button
              class="confirmation__btn"
              size="md"
              type="default"
              outline
              @click.native="closeModal"
              >No</p-button
            >
          </div>
        </div>
      </card>
    </div>
  </modal>
</template>
<script>
import Modal from "./CustomModal";

export default {
  components: {
    Modal
  },
  computed: {
    task() {
      return this.$store.getters.getTasksDeletingId;
    },
    study() {
      return this.$store.getters.getStudiesDeletingId;
    },
    datapoint() {
      return this.$store.getters.getDatapointsDeletingId;
    },
    user() {
      return this.$store.getters.getUsersDeletingId;
    },
    scheme() {
      return this.$store.getters.getSchemesDeletingId;
    },
    schemeName() {
      return this.$store.getters.getSchemeName;
    },
    schemeType() {
      return this.$store.getters.getSchemeType;
    },
    schemeDescription() {
      return this.$store.getters.getSchemeDescription;
    },
    schemeId() {
      return this.$store.getters.getSchemeId;
    },
    schemeLabels() {
      return this.$store.getters.getSchemeLabels;
    }
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleModal");
    },
    itemInterection() {
      if (this.task !== null) {
        this.$store.dispatch("deleteTask");
      } else if (this.study !== null) {
        this.$store.dispatch("deleteStudy");
      } else if (this.datapoint !== null) {
        this.$store.dispatch("deleteDatapoint");
      } else if (this.user !== null) {
        this.$store.dispatch("deleteUser");
      } else if (this.schemeId !== "") {
        console.log(this.schemeDescription);
        let schemeDescription = this.schemeLabels;

        if (this.schemeType === "form") {
          schemeDescription = this.schemeDescription;
        }

        this.$store.dispatch("updateScheme", {
          name: this.schemeName,
          type: this.schemeType,
          description: JSON.stringify(schemeDescription)
        });
      } else if (this.scheme !== null) {
        this.$store.dispatch("deleteScheme");
      } else {
        console.log("Smth wrong with id");
      }

      this.closeModal();
    }
  }
};
</script>
<style lang="scss" scoped>
.confirmation {
  width: 300px;
  height: 150px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  text-align: center;

  &__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  &__question {
    margin-bottom: 30px;
  }

  &__choose {
    display: flex;
    justify-content: center;
  }

  &__btn {
    margin: 0 10px;
    width: 100px;
  }
}
</style>
